import React, { FC } from "react";
import { IconContainer } from "shared/icons/IconContainer";

export const ShortTextBlockIcon: FC<React.ComponentProps<typeof IconContainer>> = ({ ...props }) => (
  <IconContainer {...props} viewBox="0 0 16 16">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.60156 5.3998C1.60156 5.06843 1.87019 4.7998 2.20156 4.7998H13.8016C14.1329 4.7998 14.4016 5.06843 14.4016 5.3998C14.4016 5.73118 14.1329 5.9998 13.8016 5.9998H2.20156C1.87019 5.9998 1.60156 5.73118 1.60156 5.3998ZM1.60156 10.5998C1.60156 10.2684 1.87019 9.9998 2.20156 9.9998H13.8016C14.1329 9.9998 14.4016 10.2684 14.4016 10.5998C14.4016 10.9312 14.1329 11.1998 13.8016 11.1998H2.20156C1.87019 11.1998 1.60156 10.9312 1.60156 10.5998Z"
      fill="currentColor"
    />
  </IconContainer>
);
